// Appels HTTP typés vers /api/company-settings.

import { api } from "./client";

export interface CompanySettings {
  id: string;
  tenant_id: string;
  company_name: string | null;
  address_line1: string | null;
  address_line2: string | null;
  city: string | null;
  postal_code: string | null;
  country: string | null;
  siret: string | null;
  vat_number: string | null;
  email: string | null;
  phone: string | null;
  website: string | null;
  logo_url: string | null;
  logo_storage_key: string | null;
  legal_footer: string | null;
  bank_name: string | null;
  iban: string | null;
  bic: string | null;
  created_at: string;
  updated_at: string;
}

export type CompanySettingsUpdate = Partial<
  Omit<
    CompanySettings,
    "id" | "tenant_id" | "created_at" | "updated_at" | "logo_url" | "logo_storage_key"
  >
>;

export const companySettingsApi = {
  get: () => api.get<CompanySettings>("/api/company-settings"),

  update: (data: CompanySettingsUpdate) =>
    api.patch<CompanySettings>("/api/company-settings", data),

  uploadLogo: (file: File) => {
    const form = new FormData();
    form.append("file", file);
    return api.postForm<CompanySettings>("/api/company-settings/logo", form);
  },
};
